module.exports = __webpack_public_path__ + "media/images/watermark-d99c56884d2bfbfe8627af57dcb88ac8.png";